/* eslint-disable react/prop-types */
import * as React from 'react';
import { connect } from 'react-redux';
import { INBNToast, IToast } from '@telstra-connect/service-requests/state/nbn-services-list';
import { Components } from '@telstra-connect/service-requests/activity-tracking';
import { dismissToast } from '@telstra-connect/service-requests/methods/create-nbn-test/load';
import Toast from 'telstra-ui/components/toast/Toast';
import { IServiceRequestsAppState } from '../../../../store-state';
import { headerName, messages } from '@telstra-connect/service-requests/helpers/common-static-data';
import { Button } from 'telstra-ui/components/button/Button';
import { withRouter, IWithRouterProps } from '@utils/withRouterWrapper';
import { Application } from '../../../../index';
interface IToastStateProps {
    toastData: INBNToast;
}

interface IToastDispatchProps {
    dismissresult: (serviceId: string, diagnosticResult: string) => void;
}

export class ToastComponent extends React.Component<IToastStateProps & IToastDispatchProps & IWithRouterProps<{}>, {}> {
    // eslint-disable-next-line react/no-deprecated
    public componentWillReceiveProps(newProps: IToastStateProps) {
        if (newProps.toastData.toastTagFlag) {
            if (newProps.toastData.toastCount && newProps.toastData.toastCount > 1) {
                for (let i = 1; i <= newProps.toastData.toastCount; i++) {
                    const description = this.getDescription(
                        newProps.toastData.data[newProps.toastData.data.length - i]);
                    this.tagOmniture(description);
                }
            } else {
                const description = this.getDescription(newProps.toastData.data[newProps.toastData.data.length - 1]);
                this.tagOmniture(description);
            }
        }
    }
    public render() {
        const list = [];
        const mobileList = [];
        this.props.toastData.data.map((item, index) => {
            let testName = '';
            let testing = '';
            let passed = '';
            let failed = '';
            let incomplete = '';
            let success = '';
            let pass = '';
            let toastDescription = '';
            if (item.diagnosticName === 'loopbacktest') {
                testName = headerName.loopback;
                testing = headerName.loopbackTesting;
                passed = headerName.loopbackPassed;
                failed = headerName.loopbackFailed;
                incomplete = headerName.loopbackIncomplete;
                success = messages.testSuccess;
                pass = ' passed for ';
            } else if (item.diagnosticName === 'portreset') {
                testName = headerName.PortReset;
                testing = headerName.portresetting;
                passed = headerName.portresetComplete;
                failed = headerName.portresetFailed;
                incomplete = headerName.portresetIncomplete;
                success = messages.testComplete;
                pass = ' complete for ';
            }

            if (item.diagnosticResult) {
                if (item.diagnosticResult === 'Pass') {
                    toastDescription = item.noOfServices && item.noOfServices > 1 ?
                        testName + pass + item.noOfServices + ' service ID(s).'
                        : testName + success + item.serviceId + '.';
                    list.push({
                        id: index,
                        time: Date.now(),
                        description: toastDescription,
                        actionButton: (
                            <Button variant="primary" size="small"
                                id={item.serviceId + '-' + item.diagnosticResult}
                                onClick={this.viewResults}>View Results</Button>
                        ),
                        type: 'success'
                    });
                    mobileList.push({
                        id: index,
                        time: Date.now(),
                        description: item.noOfServices && item.noOfServices > 1 ?
                            testName + pass + item.noOfServices + '       service ID(s).' :
                            passed + messages.serviceID + item.serviceId + '.',
                        actionButton: (
                            <Button variant="primary" size="small"
                                id={item.serviceId + '-' + item.diagnosticResult}
                                onClick={this.viewResults}>View Results</Button>
                        ),
                        type: 'success'
                    });
                } else if (item.diagnosticResult === 'Fail') {
                    toastDescription = item.noOfServices && item.noOfServices > 1 ?
                        testName + ' failed for ' + item.noOfServices + ' service ID(s).'
                        : testName + messages.testFailed + item.serviceId + '.';
                    list.push({
                        id: index,
                        time: Date.now(),
                        description: toastDescription,
                        actionButton: (
                            <Button variant="primary" size="small"
                                id={item.serviceId + '-' + item.diagnosticResult}
                                onClick={this.viewResults}>View Results</Button>
                        ),
                        type: 'warning'
                    });
                    mobileList.push({
                        id: index,
                        time: Date.now(),
                        description: item.noOfServices && item.noOfServices > 1 ?
                            testName + ' failed for ' + item.noOfServices + '        service ID(s).' :
                            failed + messages.serviceID + item.serviceId + '.',
                        actionButton: (
                            <Button variant="primary" size="small"
                                id={item.serviceId + '-' + item.diagnosticResult}
                                onClick={this.viewResults}>View Results</Button>
                        ),
                        type: 'warning'
                    });
                } else if (item.diagnosticResult === 'Error') {
                    toastDescription = item.noOfServices && item.noOfServices > 1 ?
                        `Couldn't complete test for ` + item.noOfServices + ' service ID(s).'
                        : `Couldn't complete test.`
                    list.push({
                        id: index,
                        time: Date.now(),
                        description: toastDescription,
                        type: 'warning',
                        actionButton: (
                            <Button variant="primary" size="small" id={item.serviceId + '-' + item.diagnosticResult}
                                onClick={this.viewResults}>View and try again</Button>
                        ),
                    });
                    mobileList.push({
                        id: index,
                        time: Date.now(),
                        description: item.noOfServices && item.noOfServices > 1 ?
                            `Couldn't complete test for ` + item.noOfServices + '  service ID(s).'
                            : `Couldn't complete test.`,
                        type: 'warning',
                        actionButton: (
                            <Button variant="primary" size="small" id={item.serviceId + '-' + item.diagnosticResult}
                                onClick={this.viewResults}>View and try again</Button>
                        ),
                    });
                } else {
                    toastDescription = item.noOfServices && item.noOfServices > 1 ?
                        messages.testIncomplete + testName + ' for ' + item.noOfServices + ' service ID(s).'
                        : messages.testIncomplete + testName + ' for service ID ' + item.serviceId + '.';
                    list.push({
                        id: index,
                        time: Date.now(),
                        description: toastDescription,
                        type: 'warning',
                        actionButton: (
                            <Button variant="primary" size="small"
                                id={item.serviceId + '-' + item.diagnosticResult}
                                onClick={this.viewResults}>View and try again</Button>
                        ),
                    });
                    mobileList.push({
                        id: index,
                        time: Date.now(),
                        description: item.noOfServices && item.noOfServices > 1 ?
                            messages.testIncomplete + testName + ' for ' + item.noOfServices + ' service ID(s).'
                            : incomplete + messages.serviceID + item.serviceId + '.',
                        actionButton: (
                            <Button variant="primary" size="small" id={item.serviceId + '-' + item.diagnosticResult}
                                onClick={this.viewResults}>View and try again</Button>
                        ),
                        type: 'warning'
                    })

                }
            } else if (item.diagnosticStatus === 'QUEUED') {
                toastDescription = item.noOfServices && item.noOfServices > 1 ? testName + ' in progress for ' +
                    item.noOfServices + ' service ID(s)' :
                    testName + messages.testInProgress + item.serviceId;
                list.push({
                    id: index,
                    time: Date.now(),
                    description: toastDescription + messages.updateMsg,
                    type: 'generic'
                });
                mobileList.push({
                    id: index,
                    time: Date.now(),
                    description: item.noOfServices && item.noOfServices > 1 ? testing + 'for ' +
                        item.noOfServices + ' service ID(s). ' + messages.refreshMsg :
                        testing + '    ' + item.serviceId + '.' + messages.refreshMsg,
                    type: 'generic'
                });
            }
        })

        return (<NBNToast listArr={list} mobileListArr={mobileList} />)

    }
    private getDescription = (item: IToast) => {
        let testName = '';
        if (item.diagnosticName === 'loopbacktest') {
            testName = headerName.loopback;
        } else if (item.diagnosticName === 'portreset') {
            testName = headerName.PortReset;
        }

        if (item.diagnosticResult) {
            return item.noOfServices > 1 ? testName + ' ' + item.diagnosticResult + ' for ' + item.noOfServices +
                ' service ID(s).' : testName + ' ' + item.diagnosticResult + ' for service ID ' + item.serviceId + '.';
        } else if (item.diagnosticStatus === 'QUEUED') {
            return item.noOfServices > 1 ? testName + ' in progress for ' + item.noOfServices + ' service ID(s).' :
                testName + messages.testInProgress + item.serviceId + '.';
        }
    }
    private tagOmniture = (description) => {
        Application.tracker.trackLink(Components.nbnLandingPage,
            Components.nbnToastTracking(description));
    }
    private viewResults = (event) => {
        this.props.navigate('/app/service-requests/nbn-diagnostics');
        Application.tracker.trackLink(Components.nbnLandingPage,
            Components.nbnViewResults);
        const param = event.target.id.split('-');
        this.props.dismissresult(param[0], param[1]);
    }
}

const NBNToast = ({ listArr, mobileListArr }) => {
    return (
        <div className="srm-nbn-toast-component">
            <div className={`hidden-xs`}>
                <Toast toastList={listArr} position="top-right"
                    autoDelete={false} />
            </div>
            <div className={`visible-xs`}>
                <Toast toastList={mobileListArr} position="top-right"
                    autoDelete={false} />
            </div>
        </div>
    )
}

const mapStateToProps = (state: IServiceRequestsAppState): IToastStateProps => {
    return {
        toastData: state.serviceRequests.nbnServiceListDetails.data.toast
    }
};

const mapDispatchToProps = (dispatch): IToastDispatchProps => ({
    dismissresult: (serviceId: string, diagnosticResult: string) =>
        dispatch(dismissToast(serviceId, diagnosticResult))
}
)

export const NBNToastComponent = withRouter(
    connect<IToastStateProps, IToastDispatchProps, Readonly<IWithRouterProps>,
    IServiceRequestsAppState>(mapStateToProps, mapDispatchToProps)(ToastComponent)
);
